import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Layout from "../../components/Layout/Frontend/Layout";
import { Box } from "@mui/material";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#041E42",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(
  name,
  speaking,
  reading,
  writing,
  listening,
  totalMark,
  questionNumbers,
  scorePerQuestion
) {
  return {
    name,
    speaking,
    reading,
    writing,
    listening,
    totalMark,
    questionNumbers,
    scorePerQuestion,
  };
}

const rows = [
  createData("Read Aloud", 8.46, 0, 0, 0, 8.46, "6-7", 15),
  createData("Repeat Sentence", 14.04, 0, 0, 15.03, 29.07, "10-12", 13),
  createData("Describe Image", 28.17, 0, 0, 0, 28.17, "5-6", 16),
  createData("Retell Lecture", 11.25, 0, 0, 11.97, 23.22, "2-3", 15),
  createData("Answer Short Questions", 0, 0, 0, 3.78, 3.78, "5-6", "1"),
  createData("Summarize Group Discussion", 16.92, 0, 0, 18, 34.92, "2-3", "16"),
  createData("Respond to a Situation", 11.25, 0, 0, 0, 11.25, "2-3", "16"),
  createData("Summarize Written Text", 0, 20.25, 24.93, 0, 45.18, "2", 9),
  createData("Write Essay", 0, 0, 27.72, 0, 27.72, "1", "26"),
  createData("Fill in the Blank (Dropdown)", 0, 24.75, 0, 0, 24.75, "5-6", 6),
  createData("R Multiple Answers", 0, 4.5, 0, 0, 4.5, "2-3", 2),
  createData("Re-order Paragraphs", 0, 7.92, 0, 0, 7.92, "2-3", 4),
  createData("R Fill in the Blank", 0, 16.92, 0, 0, 16.92, "4-5", 5),
  createData("R Single Answer", 0, 2.25, 0, 0, 2.25, "2-3", 1),
  createData("Summarized Spoken Text", 0, 0, 16.65, 9, 25.65, "1", 12),
  createData("L Multiple Answers", 0, 0, 0, 2.97, 2.97, "2-3", 2),
  createData("L Fill in the Blank", 0, 0, 0, 6.75, 6.75, "2-3", 5),
  createData("Highlight Correct Summary", 0, 2.25, 0, 1.53, 3.78, "2-3", 1),
  createData("L Single Answer", 0, 0, 0, 1.53, 1.53, "2-3", 1),
  createData("Select Missing Word", 0, 0, 0, 0.72, 0.72, "1-2", 1),
  createData("Write From Dictation", 0, 0, 20.79, 11.25, 32.04, "3-4", 12),
  createData("Highlight Incorrect Word", 0, 11.25, 0, 7.47, 18.72, "2-3", 6),
];

export default function MarkingPage() {
  return (
    <Layout>
      <Box
        sx={{
          bgcolor: "rgb(231 239 254)",
          display: "flex",
          justifyContent: "center",

          width: "100%",
        }}
      >
        <Box
          sx={{
            width: "80%",
            maxWidth: "1400px",
            px: "2rem",
            py: "2rem",
          }}
        >
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 700, bgcolor: "inherit" }}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={1} sx={{ textAlign: "center" }}>
                    Section (Category)
                  </StyledTableCell>
                  <StyledTableCell colSpan={7} sx={{ textAlign: "center" }}>
                    Mark Contribution
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell align="right"></StyledTableCell>
                  <StyledTableCell align="right">Total Mark</StyledTableCell>
                  <StyledTableCell align="right">
                    Question Numbers
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    Score per Question
                  </StyledTableCell>
                  <StyledTableCell align="right">Speaking</StyledTableCell>
                  <StyledTableCell align="right">Reading</StyledTableCell>
                  <StyledTableCell align="right">Writing</StyledTableCell>
                  <StyledTableCell align="right">Listening</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell
                      component="th"
                      scope="row"
                      sx={{ borderRight: "1px solid #d7cbcb" }}
                    >
                      {row.name}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.totalMark !== 0 ? row.totalMark : "-"}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.questionNumbers !== 0 ? row.questionNumbers : "-"}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.scorePerQuestion !== 0 ? row.scorePerQuestion : "-"}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.speaking !== 0 ? row.speaking : "-"}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.reading !== 0 ? row.reading : "-"}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.writing !== 0 ? row.writing : "-"}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.listening !== 0 ? row.listening : "-"}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
                <StyledTableRow>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    sx={{
                      background: "yellow",
                      textAlign: "center",
                      borderRight: "1px solid #d7cbcb",
                    }}
                  >
                    Final Mark
                  </StyledTableCell>
                  <StyledTableCell align="right">360.27</StyledTableCell>
                  <StyledTableCell align="right"></StyledTableCell>
                  <StyledTableCell align="right"></StyledTableCell>
                  <StyledTableCell align="right">90.09</StyledTableCell>
                  <StyledTableCell align="right">90.09</StyledTableCell>
                  <StyledTableCell align="right">90.09</StyledTableCell>
                  <StyledTableCell align="right">90</StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Layout>
  );
}
